import { TableCell } from '@mui/material';
import PropTypes from 'prop-types';
import { Box } from '@mui/system';

export const WorklogIssueCell = ({ 
    projectSummary,    
    issueSummary,
}) => (
    <TableCell>
        <Box title={projectSummary}>
            {projectSummary}
        </Box>
        <Box title={issueSummary}>
            {issueSummary}
        </Box>
    </TableCell>
);

WorklogIssueCell.propTypes = {
    projectSummary: PropTypes.string,
    issueSummary: PropTypes.string,
};
WorklogIssueCell.defaultProps = {
    projectSummary: '',
    issueSummary: '',
};
